export interface IResponseBFF<T> {
  error: string;
  result: T;
}
